module.exports = __webpack_public_path__ + "static/warner-bf2ca6fe391569360f57f9be6c0d2a75.jpg";